import * as Constants from "../common/Constants";
import { Auth } from "../common/Common";

const initialState = {
    isAuthorizing: false,
    isRefreshing: false,
    isFailed: false,
    isAuth: false,
    isLogingout: false,
    isLoggedOut: false,
    error: null,
    me: null,
    clientModules: null,
    refreshHandler: null
};

var auth = Auth.get();
if (auth) {
    initialState.me = auth.me;
    initialState.auth = auth;
    let ex = new Date(auth.expiration);
    initialState.isAuth = ex.getTime() > new Date().getTime();
}

export default function loginReducer(state = initialState, action) {
    var newState = { ...state };
    
    newState.isFailed = false;
    newState.isAuthorizing = false;
    newState.isRefreshing = false;
    newState.isLogingout = false;
    newState.isLoggedOut = false;
    newState.error = null;
    
    switch (action.type) {
        case Constants.REQUEST_LOGIN:
            newState.isAuthorizing = true;
            return newState;

        case Constants.REQUEST_REFRESH_TOKEN:
            newState.isRefreshing = true;
            return newState;

        case Constants.ACCEPT_LOGIN:
            
            newState.isAuth = true;
            Auth.set(action.authData);
            newState.me = action.authData.me;
            newState.auth = action.authData;

            return newState;

        case Constants.ACCEPT_REFRESH_TOKEN:

            newState.isRefreshing = false;
            newState.isAuth = true;
            newState.auth = action.authData;
            newState.me = action.authData.me;
            Auth.set(action.authData);
            return newState;

        case Constants.HAS_LOGIN:
            
            newState.isAuth = true;
            return newState;

        case Constants.INVALID_LOGIN:
            newState.me = null;
            newState.auth = null;
            newState.isFailed = true;
            newState.isAuthorizing = false;
            newState.isAuth = false;
            newState.error = action.error;
            return newState;

        case Constants.NO_LOGIN:
            return newState;

        case Constants.REQUEST_LOGOUT:
            newState.isLogingout = true;
            return newState;

        case Constants.SUCCESS_LOGOUT:
            localStorage.removeItem(Constants.AUTH_DATA);
            newState.isAuth = false;
            newState.me = null;
            newState.auth = null;
            newState.isLoggedOut = true;
            return newState;
            
        case Constants.SET_CLIENT_MODULES:
            Auth.setClientModules(action.payload);
            newState.clientModules = action.payload;
            return newState;

        case Constants.GET_CLIENT_MODULES:
            newState.clientModules = Auth.getClientModules();
            return newState;

        case Constants.ADD_REFRESH_HANDLER:
            newState.refreshHandler = action.payload;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/LoginReducer.js